//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import { getLocal, setLocal } from '@/utils/globalState'
export default {
  name: 'UserInfo',
  extends: vComponent,
  data () {
    return {
      searchObj: {
        key: '',
        val: ''
      },
      options: [
        { label: '姓名', key: 'VIP_NAME' },
        { label: '電話', key: 'VIP_TEL' },
        { label: '生日', key: 'VIP_BIRTHDAY' },
        { label: '會員編號', key: 'VIP_CODE' }
        // { label: '會員備註', key: 'VIP_MEMO' }
      ],
      selectedLabel: '請選擇'
    }
  },
  computed: {
    ...mapGetters([
      'site',
      'theme',
      'siteConfig'
    ])
  },
  created () {
    this.options.push({ label: this.siteConfig.memo.text, key: 'VIP_MEMO' })
    const tmpKey = getLocal('searchVipBar')
    if (tmpKey !== null) {
      this.searchObj.key = tmpKey
      let label = null
      this.options.forEach(item => {
        if (tmpKey === item.key) label = item.label
      })
      if (label !== null) this.selectedLabel = label
    }
  },
  mounted () {
  },
  methods: {
    onOptionClick (key) {
      this.searchObj.key = key
      setLocal('searchVipBar', this.searchObj.key)
      let label = null
      this.options.forEach(item => {
        if (key === item.key) label = item.label
      })
      if (label !== null) this.selectedLabel = label
    },
    async doQuery () {
      // 已經在viplist上 做emit 否則就做to
      if (this.$route.path.indexOf('viplist') !== -1) {
        this.emit('SearchVipBar.Search', this.searchObj)
      } else {
        const url = `/viplist?key=${this.searchObj.key}&val=${this.searchObj.val}`
        this.to(url)
      }
    }
  }
}
